import React, { useEffect, useMemo, useState } from "react";
import { useIntl } from "react-intl";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import AnimatedMainContainer from "../../../components/AnimatedMainContainer";
import { useDispatch, useSelector } from "react-redux";
import { getEventList } from "../../../redux/modules/analytics/actions";
import { getPreviewCourseList } from "../../../redux/modules/informaAcademy/actions";
import HomepageForm from "../components/form";
import PreviewHomePage from "../components/preview";
import api from "../../../service";
import { useToast } from "../../../hooks/toast";

export default function CreateNewHomePage() {
  const [step, setStep] = useState("form");
  const intl = useIntl();
  const history = useHistory();
  const { eventId } = useParams();

  const { events } = useSelector((state) => state.analytics);
  const { courses: eventCourses, isLoading } = useSelector(
    (state) => state.informaAcademy
  );
  const [banners, setBanners] = useState([]);
  const [courses, setCourses] = useState([]);
  const [choosenCourses, setChoosenCourses] = useState([]);
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);
  const { addToast } = useToast();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  useEffect(() => {
    dispatch(getEventList());
    dispatch(getPreviewCourseList({ eventId }));
  }, [dispatch, eventId]);

  const eventName = useMemo(() => {
    if (!events) return "";
    const name = events.find((event) => event.value === +eventId)?.label;
    return name ? ` | ${name}` : "";
  }, [events, eventId]);

  const createHomePage = async ({ body }) => {
    try {
      await api.post("academy/banners", body, config);
      addToast({
        type: "success",
        title: intl.formatMessage({
          id: "success",
        }),
        description: intl.formatMessage({
          id: "success.homepage_created",
        }),
      });
      history.push(`/admin/informa-academy/manage-homepage/`);
    } catch (error) {
      addToast({
        type: "error",
        title: intl.formatMessage({
          id: "error",
        }),
        description: intl.formatMessage({
          id: "error.homepage_created",
        }),
      });
    }
  };

  const onSubmit = async () => {
    const body = convertToFormData({
      banners,
      courses,
      eventId,
    });

    return await createHomePage({ body });
  };

  if (isLoading) return null;

  if (step === "form")
    return (
      <AnimatedMainContainer
        breadcrumb={
          intl.formatMessage({
            id: "breadcrumb.create-manage-homepage-banner",
          }) + eventName
        }
      >
        <HomepageForm
          defaultValues={{
            banners,
          }}
          eventCourses={eventCourses}
          setBanners={setBanners}
          setCourses={setCourses}
          preview={() => setStep("preview")}
          choosenCourses={choosenCourses}
          setChoosenCourses={setChoosenCourses}
        />
      </AnimatedMainContainer>
    );

  if (step === "preview")
    return (
      <AnimatedMainContainer>
        <PreviewHomePage
          banners={banners}
          courses={courses}
          editRedirect={() => setStep("form")}
          isForm
          onSubmit={onSubmit}
          title={
            intl.formatMessage({
              id: "breadcrumb.create-manage-homepage-banner",
            }) + eventName
          }
        />
      </AnimatedMainContainer>
    );

  return null;
}

function formatDate(dateString) {
  const date = new Date(dateString);
  return date.toISOString();
}

export function convertToFormData({ banners, courses, eventId, homePageId }) {
  const formData = new FormData();

  if (homePageId) formData.append("homePageId", homePageId);

  formData.append("eventId", eventId);

  banners.forEach((banner, index) => {
    if (homePageId && typeof banner.id === "number") {
      formData.append(`banners[${index}].id`, banner.id);
    }

    formData.append(`banners[${index}].title`, banner.title);
    formData.append(`banners[${index}].buttonUrl`, banner.buttonUrl);
    formData.append(
      `banners[${index}].startDate`,
      formatDate(banner.startDate).replace("Z", "")
    );
    formData.append(
      `banners[${index}].endDate`,
      banner.endDate ? formatDate(banner.endDate).replace("Z", "") : ""
    );
    formData.append(`banners[${index}].description`, banner.description);
    formData.append(`banners[${index}].image`, banner.bannerImage);
  });

  courses.forEach((course, index) => {
    formData.append(`courses[${index}].courseId`, course.courseId);
    formData.append(`courses[${index}].courseOrder`, course.courseOrder);
    formData.append(`courses[${index}].visible`, course.visible);
  });

  return formData;
}
